import React, { Component } from 'react';
import Search from '../../../components/Search';
import DataTable from '../../../components/DataTable';
import { connect } from 'react-redux'
import {Card, CardBody, CardTitle, CardHeader, CardBlock} from "reactstrap";
import { setSearchData } from '../../../actions/search';
import Loader from '../../../components/Loader';
import { getAllReportTypes } from '../../../actions/report';

class ReportOverview extends Component {

	constructor(props,context) {
        super(props,context);

        this.additionalColumns = [
        {
            Header: 'Actief',
            accessor: 'is_active',
            Cell: props => <span>{props.value === '1' ? <i className="fa fa-check"></i> : <i className="fa fa-times"></i>}</span>
        },  
        {
            Header: 'Is een gobale rapportage?',
            accessor: 'is_global',
            Cell: props => <span>{props.value === '1' ? <i className="fa fa-check"></i> : <i className="fa fa-times"></i>}</span>
        },       
        {
            Header: 'Bekijken',
            accessor: 'id',
            Cell: props => <span><a href={props.row._original.is_global == '1' ? '/#/report/update/'+props.value : '/#/report/update/'+props.value} style={{display : 'inline'}} className="nav-link"><i className="fa fa-eye"></i> Bekijken</a></span>
        }
        ]         

    }


	componentWillMount() {
        if(this.props.clientPath.clientPath) {
            this.props.getAllReportTypes(this.props.clientPath.clientPath)
        }
    	
      }
      
     componentDidUpdate(prevProps) {
        
        if(prevProps.reportData != this.props.reportData)
            this.props.updateSearchData(this.props.reportData.data)
    }

	render() {
        return (            
               this.props.reportData.data ?
                <Card>
    				<CardHeader><Search data={this.props.reportData.data} keys_to_filter={['name', 'addresses.street', 'addresses.zipcode', 'addresses.city']}/></CardHeader>
                    <CardBody>                    
                        <CardTitle><i className="fa fa-align-justify"></i> Rapportage overzicht</CardTitle>
                        <DataTable additionalColumns={this.additionalColumns} data={this.props.searchData.data ? this.props.searchData.data : this.props.reportData.data} columns={this.props.reportData.columns} />
                    </CardBody>
                </Card>
               : <Loader />
                       
        )
  	}
}


function mapStateToProps(state, ownProps) {
 
    return {
        clientData: state.ClientDataReducer,
        searchData: state.SearchDataReducer,
        reportData : state.ReportReducer,
        clientPath: state.clientPathReducer,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateSearchData: (data) => dispatch(setSearchData(data)),
        getAllReportTypes: (url) => dispatch(getAllReportTypes(url + '/api/report/action/getReports')),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReportOverview )



// WEBPACK FOOTER //
// ./src/views/Report/Overview/index.js